import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const pageTitles: Record<string, string> = {
  "/": "Kolaborate BPO - Africa's Premier Team Augmentation & Outsourcing Partner",
  "/services":
    "Our Services - Kolaborate BPO | Software Development & Data Services",
  "/portfolio": "Portfolio & Case Studies - Kolaborate BPO | Success Stories",
  "/about": "About Us - Kolaborate BPO | Bridging Global Talent Gap",
  "/contact": "Contact Us - Kolaborate BPO | Get Your Team Ready in 2 Weeks",
};

export const usePageTitle = () => {
  const location = useLocation();

  useEffect(() => {
    const title = pageTitles[location.pathname] || "Kolaborate BPO";
    document.title = title;

    // Add meta description for better SEO
    const descriptions: Record<string, string> = {
      "/": "Bridge the global talent gap with Kolaborate BPO. Access highly skilled African developers, data experts, and digital professionals. 72% cost savings, teams ready in 2 weeks.",
      "/services":
        "Comprehensive BPO services including software development, AI & ML, data annotation, digital marketing, and team augmentation from African tech professionals.",
      "/portfolio":
        "Explore our successful projects and case studies. See how Kolaborate BPO has helped businesses scale with African talent.",
      "/about":
        "Learn about Kolaborate BPO's mission to bridge the global talent gap while creating dignified work opportunities for young Africans.",
      "/contact":
        "Ready to transform your team? Contact Kolaborate BPO for a free consultation and get your team ready in under 2 weeks.",
    };

    const description =
      descriptions[location.pathname] ||
      "Africa's premier business process outsourcing and team augmentation company";

    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute("content", description);
    }
  }, [location.pathname]);
};
